/* Funcao padrao para gerar datas no app */

import moment from "moment-timezone";

export default function geraData(date = new Date(), mascara = 'YYYY-MM-DD HH:mm:ss.SSS', timezone = 'America/Sao_Paulo') {
    return moment(date).tz(timezone).format(mascara);
}

export function converterDataApiParaLocal(dataRaw, mascara = 'YYYY-MM-DD HH:mm:ss.SSS', timezone = 'America/Sao_Paulo') {
    if (!dataRaw || dataRaw === 'null' || dataRaw === '') return null;
    
    let mUtc;
    if (typeof dataRaw === 'string') {
        mUtc = moment.utc(dataRaw, [
            moment.ISO_8601,
            'YYYY-MM-DD HH:mm:ss.SSS',
            'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DD HH:mm',
            'YYYY-MM-DD'
        ]);
    } else {
        mUtc = moment.utc(dataRaw);
    }

    if (!mUtc.isValid()) return null;
    return mUtc.tz(timezone).format(mascara);
}